'use strict';

import PropTypes from 'prop-types';
import React, { Component } from 'react';

const TICK_INTERVALL = 1000; // 1 sec

class CountDownNext extends Component {
    constructor(props) {
        super(props);

        this.state = {
            count: props.startCount,
        };
    }

    componentDidMount() {
        const { startDelay } = this.props;

        let animationFrameId;
        this.id = setTimeout(() => {
            this.tick(); //first tick

            this.id = setInterval(() => {
                if (!animationFrameId) {
                    animationFrameId = requestAnimationFrame(() => {
                        this.tick();
                        animationFrameId = null;
                    });
                }
            }, TICK_INTERVALL);
        }, startDelay || 0);
    }

    componentWillUnmount() {
        this.stopCountdown();
    }

    tick() {
        const next = this.state.count - 1;

        if (next === 0) {
            this.stopCountdown();

            if (this.props.onComplete) {
                this.props.onComplete();
            }
        } else {
            this.setState({
                count: next,
            });
        }
    }

    stopCountdown() {
        if (this.id) {
            clearInterval(this.id);
        }
    }

    render() {
        const { count } = this.state;

        return (
            <span className="play_end-screen-next__count-down-info">
                Nästa startar{' '}
                <span className="play_end-screen-next__count-down-info--nowrap">om {count} sek</span>
            </span>
        );
    }
}

CountDownNext.propTypes = {
    startCount: PropTypes.number.isRequired,
    startDelay: PropTypes.number,
    onComplete: PropTypes.func,
};

export default CountDownNext;
